import React from 'react';
import PropTypes from 'prop-types';
import { Icon as AntIcon } from 'antd';

const Icon = (props) => <AntIcon type={props.name} style={props.style} onClick={props.onClick} />;

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
};

Icon.defaultProps = {
  style: {},
  onClick: () => false,
};

export default Icon;
